import { computed, observable } from 'mobx';
import BaseSwiperStore from '../../components/swiper/base-swiper/store';
import { useEffect } from 'react';

const styles = require('./index.less');

class ImageModalStore {
  imageModalSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: false
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev'
      // }
    }
  });

  @observable imagesList;

  @observable currentIndex = 0;

  //弹窗状态
  @observable modalState;

  /**
   * 是否最后
   * @returns {boolean}
   */
  @computed
  get isDisableNext() {
    return this.currentIndex === this.imagesList.length - 1;
  }

  /**
   * 是否第一张
   * @returns {boolean}
   */
  @computed
  get isDisablePrev() {
    return this.currentIndex === 0;
  }

  /**
   * 后退
   */
  onPrevClick = () => {
    this.currentIndex -= 1;
  };

  /**
   * 前进
   */
  onNextClick = () => {
    this.currentIndex += 1;
  };

  /**
   * 更新弹窗打开/关闭状态
   */
  onModalStateChange = state => {
    this.modalState = state;
  };
  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useEffect(
      () => {
        this.imageModalSwiperStore.onChange(this.currentIndex);
      },
      [this.currentIndex]
    );
  }
}
export default ImageModalStore;
